// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.5 14.5C18.2614 14.5 20.5 16.7386 20.5 19.5V22H3.5V19.5C3.5 16.7386 5.73858 14.5 8.5 14.5H15.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 3H14C16.7614 3 19 5.23858 19 8C19 10.7614 16.7614 13 14 13H10C7.23858 13 5 10.7614 5 8C5 5.23858 7.23858 3 10 3H11V1H13V3ZM10 6.75C9.30964 6.75 8.75 7.30964 8.75 8C8.75 8.69036 9.30964 9.25 10 9.25C10.6904 9.25 11.25 8.69036 11.25 8C11.25 7.30964 10.6904 6.75 10 6.75ZM14 6.75C13.3096 6.75 12.75 7.30964 12.75 8C12.75 8.69036 13.3096 9.25 14 9.25C14.6904 9.25 15.25 8.69036 15.25 8C15.25 7.30964 14.6904 6.75 14 6.75Z"}}]};

const Robot1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'robot-1-filled',
    ref,
    icon: element,
  },
));

Robot1FilledIcon.displayName = 'Robot1FilledIcon';

export default Robot1FilledIcon;
